import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { forkJoin } from 'rxjs';
import { AdjuntoService } from '../../_services/adjunto.service';
import { ProductoTroncalService } from '../../_services/producto-troncal.service';
import { ProductoTroncal } from '../../_models/producto-troncal';
import { ProductoTroncalProductoAgrupadoService } from '../../_services/producto-troncal-producto-agrupado.service';
import { ProductoTroncalProductoAgrupado } from '../../_models/producto-troncal-producto-agrupado';

@Component({
  selector: 'app-productos-troncal-detalle',
  templateUrl: './productos-troncal-detalle.component.html',
  styleUrls: [ './productos-troncal-detalle.component.css' ]
})
export class ProductosTroncalDetalleComponent implements OnInit {

  productoTroncal: ProductoTroncal;
  productosAgrupados: ProductoTroncalProductoAgrupado[] = [];
  carInformacionInicial = true;
  imagen: SafeResourceUrl;

  constructor( private route: ActivatedRoute,
               private location: Location,
               private sanitizer: DomSanitizer,
               private adjService: AdjuntoService,
               private productoTroncalServicio: ProductoTroncalService,
               private productoTroncalProductoAgrupadoServicio: ProductoTroncalProductoAgrupadoService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      forkJoin(
        this.productoTroncalServicio.obtenerPorId( params[ 'id' ] ),
        this.productoTroncalProductoAgrupadoServicio.listarPorProductoTroncal( params[ 'id' ] )
      ).subscribe( ( [ productoTroncal, agrupados ] ) => {
        this.productoTroncal = productoTroncal;
        this.productosAgrupados = agrupados.filter( x => x.indicadorHabilitado );
        if ( productoTroncal.idIcono ) {
          this.cargarIcono( productoTroncal.idIcono );
        }
        this.carInformacionInicial = false;
      } );
    } );
  }

  cargarIcono( idIcono: string ) {
    this.adjService.descargarArchivo( idIcono ).subscribe( blob => {
      const reader = new FileReader();
      reader.addEventListener( 'load', () => {
        this.imagen = this.sanitizer.bypassSecurityTrustUrl( reader.result.toString() );
      }, false );
      reader.readAsDataURL( blob );
    } );
  }

  regresar() {
    this.location.back();
  }

}
